import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

interface Props {
  label: string;
  children: ReactNode;
}

/**
 * Replica `.mp-q`: la pregunta arriba y el control anclado abajo. La etiqueta crece, así que los
 * controles de una fila quedan a la misma altura aunque una pregunta ocupe dos líneas.
 */
export const FieldQuestion = ({ label, children }: Props) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 1, minWidth: 0 }}>
    <Typography variant="body2" sx={{ flex: 1, fontWeight: 500, color: "tokens.textPrimary", lineHeight: 1.4 }}>
      {label}
    </Typography>
    {children}
  </Box>
);
